import React, { useState, useEffect } from 'react';
import '@/App.css';
import { Menu, X, ChevronRight, Mail, MapPin, Facebook, Instagram, Linkedin, Check, ArrowRight } from 'lucide-react';

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState('todos');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImages, setLightboxImages] = useState([]);
  const [currentLightboxIndex, setCurrentLightboxIndex] = useState(0);
  const [lightboxTitle, setLightboxTitle] = useState('');
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    mensaje: '',
    website: '' // Honeypot field
  });
  const [formStatus, setFormStatus] = useState('');
  const [activeCapacidad, setActiveCapacidad] = useState(null);
  const [currentPage, setCurrentPage] = useState('home');

  // Hero slider images
  const heroSlides = [
    'https://www.dreamwood.com.ar/images/hero/proyecto1.jpg',
    'https://www.dreamwood.com.ar/images/hero/proyecto2.jpg',
    'https://www.dreamwood.com.ar/images/hero/proyecto3.jpg',
    'https://www.dreamwood.com.ar/images/hero/proyecto4.jpg',
    'https://www.dreamwood.com.ar/images/hero/proyecto5.jpg'
  ];

  // Auto-advance slider
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroSlides.length]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const handleFormChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.website) {
      setFormStatus('error');
      setTimeout(() => setFormStatus(''), 3000);
      return;
    }
    
    try {
      const response = await fetch('https://formspree.io/f/xykdppwj', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          nombre: formData.nombre,
          email: formData.email,
          telefono: formData.telefono,
          mensaje: formData.mensaje
        })
      });
      
      if (response.ok) {
        setFormStatus('success');
        setFormData({ nombre: '', email: '', telefono: '', mensaje: '', website: '' });
      } else {
        setFormStatus('error');
      }
      setTimeout(() => setFormStatus(''), 3000);
    } catch (error) {
      setFormStatus('error');
      setTimeout(() => setFormStatus(''), 3000);
    }
  };
  
  const portfolioItems = [
    { 
      id: 1, 
      category: 'comercial', 
      title: 'Constructora Santiago - Google',
      images: [
        '/images/portfolio/comercial/proyecto5-1.jpg',
        '/images/portfolio/comercial/proyecto5-2.jpg',
        '/images/portfolio/comercial/proyecto5-3.jpg',
        '/images/portfolio/comercial/proyecto5-4.jpg',
        '/images/portfolio/comercial/proyecto5-5.jpg',
        '/images/portfolio/comercial/proyecto5-6.jpg'
      ]
    },
    { 
      id: 2, 
      category: 'comercial', 
      title: 'Quilmes',
      images: [
        '/images/portfolio/comercial/proyecto8-1.jpg',
        '/images/portfolio/comercial/proyecto8-2.jpg',
        '/images/portfolio/comercial/proyecto8-3.jpg',
        '/images/portfolio/comercial/proyecto8-4.jpg'
      ]
    },
    { 
      id: 3, 
      category: 'comercial', 
      title: 'Hit Cowork',
      images: [
        '/images/portfolio/comercial/proyecto1-1.jpg',
        '/images/portfolio/comercial/proyecto1-2.jpg',
        '/images/portfolio/comercial/proyecto1-3.jpg',
        '/images/portfolio/comercial/proyecto1-4.jpg',
        '/images/portfolio/comercial/proyecto1-5.jpg'
      ]
    },
    { 
      id: 4, 
      category: 'comercial', 
      title: "St. Andrew's Scot School",
      images: [
        '/images/portfolio/comercial/proyecto2-1.jpg',
        '/images/portfolio/comercial/proyecto2-2.jpg',
        '/images/portfolio/comercial/proyecto2-3.jpg',
        '/images/portfolio/comercial/proyecto2-4.jpg'
      ]
    },
    { 
      id: 5, 
      category: 'comercial', 
      title: 'Distrito Padel',
      images: [
        '/images/portfolio/comercial/proyecto3-1.jpg',
        '/images/portfolio/comercial/proyecto3-2.jpg',
        '/images/portfolio/comercial/proyecto3-3.jpg',
        '/images/portfolio/comercial/proyecto3-4.jpg'
      ]
    },
    { 
      id: 6, 
      category: 'comercial', 
      title: 'Oficia Edison',
      images: [
        '/images/portfolio/comercial/proyecto4-1.jpg',
        '/images/portfolio/comercial/proyecto4-2.jpg',
        '/images/portfolio/comercial/proyecto4-3.jpg',
        '/images/portfolio/comercial/proyecto4-4.jpg'
      ]
    },
    { 
      id: 7, 
      category: 'comercial', 
      title: 'Royal Caribbean - Lakutaia',
      images: [
        '/images/portfolio/comercial/proyecto6-1.jpg',
        '/images/portfolio/comercial/proyecto6-2.jpg',
        '/images/portfolio/comercial/proyecto6-3.jpg',
        '/images/portfolio/comercial/proyecto6-4.jpg'
      ]
    },
    { 
      id: 8, 
      category: 'comercial', 
      title: 'Gamatec - Sigma Agro',
      images: [
        '/images/portfolio/comercial/proyecto7-1.jpg',
        '/images/portfolio/comercial/proyecto7-2.jpg',
        '/images/portfolio/comercial/proyecto7-3.jpg',
        '/images/portfolio/comercial/proyecto7-4.jpg'
      ]
    },
    { 
      id: 9, 
      category: 'residencial', 
      title: 'Proyecto La Clementina',
      images: [
        '/images/portfolio/residencial/proyecto1-1.jpg',
        '/images/portfolio/residencial/proyecto1-2.jpg',
        '/images/portfolio/residencial/proyecto1-3.jpg'
      ]
    },
    { 
      id: 10, 
      category: 'residencial', 
      title: 'Proyecto Libertador',
      images: [
        '/images/portfolio/residencial/proyecto2-1.jpg',
        '/images/portfolio/residencial/proyecto2-2.jpg',
        '/images/portfolio/residencial/proyecto2-3.jpg',
        '/images/portfolio/residencial/proyecto2-4.jpg'
      ]
    },
    { 
      id: 11, 
      category: 'residencial', 
      title: 'Mueble a medida',
      images: [
        '/images/portfolio/residencial/proyecto3-1.jpg',
        '/images/portfolio/residencial/proyecto3-2.jpg'
      ]
    },
    { 
      id: 12, 
      category: 'residencial', 
      title: 'Proyecto Lujan',
      images: [
        '/images/portfolio/residencial/proyecto4-1.jpg',
        '/images/portfolio/residencial/proyecto4-2.jpg',
        '/images/portfolio/residencial/proyecto4-3.jpg',
        '/images/portfolio/residencial/proyecto4-4.jpg'
      ]
    },
    { 
      id: 13, 
      category: 'residencial', 
      title: 'Proyecto Quintana',
      images: [
        '/images/portfolio/residencial/proyecto5-1.jpg',
        '/images/portfolio/residencial/proyecto5-2.jpg',
        '/images/portfolio/residencial/proyecto5-3.jpg',
        '/images/portfolio/residencial/proyecto5-4.jpg',
        '/images/portfolio/residencial/proyecto5-5.jpg',
        '/images/portfolio/residencial/proyecto5-6.jpg'
      ]
    }
  ];

  const filteredPortfolio = activeFilter === 'todos' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activeFilter);

  const openLightbox = (images, title, startIndex = 0) => {
    setLightboxImages(images);
    setLightboxTitle(title);
    setCurrentLightboxIndex(startIndex);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const nextLightboxImage = () => {
    setCurrentLightboxIndex((prev) => (prev + 1) % lightboxImages.length);
  };

  const prevLightboxImage = () => {
    setCurrentLightboxIndex((prev) => (prev - 1 + lightboxImages.length) % lightboxImages.length);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navbar */}
      <nav className="fixed w-full bg-white/95 backdrop-blur-sm shadow-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex-shrink-0">
              <img 
                src="/images/logo.png" 
                alt="DreamWood" 
                className="h-12"
              />
            </div>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-8">
              <button onClick={() => { setCurrentPage('home'); setTimeout(() => scrollToSection('inicio'), 100); }} className="text-gray-700 hover:text-slate-800 transition-colors">Inicio</button>
              <button onClick={() => { setCurrentPage('home'); setTimeout(() => scrollToSection('nosotros'), 100); }} className="text-gray-700 hover:text-slate-800 transition-colors">DreamWood</button>
              <button onClick={() => { setCurrentPage('home'); setTimeout(() => scrollToSection('metodo'), 100); }} className="text-gray-700 hover:text-slate-800 transition-colors">Método</button>
              <button onClick={() => { setCurrentPage('home'); setTimeout(() => scrollToSection('portfolio'), 100); }} className="text-gray-700 hover:text-slate-800 transition-colors">Portfolio</button>
              <button onClick={() => setCurrentPage('arquitectos')} className="text-gray-700 hover:text-slate-800 transition-colors">Arquitectos</button>
              <button onClick={() => { setCurrentPage('home'); setTimeout(() => scrollToSection('contacto'), 100); }} className="bg-slate-800 text-white px-6 py-2 rounded-full hover:bg-slate-700 transition-colors shadow-lg">Contacto</button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-gray-700">
                {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <button onClick={() => { setCurrentPage('home'); setMobileMenuOpen(false); setTimeout(() => scrollToSection('inicio'), 100); }} className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-slate-50">Inicio</button>
              <button onClick={() => { setCurrentPage('home'); setMobileMenuOpen(false); setTimeout(() => scrollToSection('nosotros'), 100); }} className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-slate-50">DreamWood</button>
              <button onClick={() => { setCurrentPage('home'); setMobileMenuOpen(false); setTimeout(() => scrollToSection('metodo'), 100); }} className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-slate-50">Método</button>
              <button onClick={() => { setCurrentPage('home'); setMobileMenuOpen(false); setTimeout(() => scrollToSection('portfolio'), 100); }} className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-slate-50">Portfolio</button>
              <button onClick={() => { setCurrentPage('arquitectos'); setMobileMenuOpen(false); }} className="block w-full text-left px-3 py-2 text-gray-700 hover:bg-slate-50">Arquitectos</button>
              <button onClick={() => { setCurrentPage('home'); setMobileMenuOpen(false); setTimeout(() => scrollToSection('contacto'), 100); }} className="block w-full text-left px-3 py-2 bg-slate-800 text-white hover:bg-slate-700">Contacto</button>
            </div>
          </div>
        )}
      </nav>

      {/* Página Para Arquitectos */}
      {currentPage === 'arquitectos' && (
        <div className="pt-20 min-h-screen bg-white">
          {/* Hero Arquitectos */}
          <section className="py-20 bg-slate-800 text-white">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <button 
                onClick={() => setCurrentPage('home')} 
                className="mb-8 text-slate-300 hover:text-white flex items-center transition-colors"
              >
                ← Volver al inicio
              </button>
              <h1 className="text-4xl sm:text-5xl font-bold mb-4">Socio técnico-industrial para estudios de arquitectura</h1>
              <p className="text-xl text-slate-300 max-w-3xl mb-8">
                Nos integramos al proceso del proyecto para desarrollar, optimizar y ejecutar mobiliario a medida con precisión técnica y cumplimiento real de obra.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <button onClick={() => { setCurrentPage('home'); setTimeout(() => scrollToSection('contacto'), 100); }} className="bg-white text-slate-800 px-8 py-4 rounded-full text-lg font-semibold hover:bg-slate-100 transition-all">
                  Agendar reunión técnica
                </button>
                <button onClick={() => { setCurrentPage('home'); setTimeout(() => scrollToSection('contacto'), 100); }} className="border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/10 transition-all">
                  Enviar documentación
                </button>
              </div>
            </div>
          </section>

          {/* Cómo nos integramos */}
          <section className="py-16 bg-white">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold mb-6 text-gray-900">Cómo nos integramos al estudio</h2>
              <p className="text-gray-600 mb-6">
                En DreamWood no intervenimos solo en etapa de presupuesto. Podemos integrarnos desde:
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                <div className="bg-slate-100 p-4 rounded-xl text-center">
                  <span className="font-semibold text-slate-800">Anteproyecto</span>
                </div>
                <div className="bg-slate-100 p-4 rounded-xl text-center">
                  <span className="font-semibold text-slate-800">Proyecto ejecutivo</span>
                </div>
                <div className="bg-slate-100 p-4 rounded-xl text-center">
                  <span className="font-semibold text-slate-800">Licitación</span>
                </div>
                <div className="bg-slate-100 p-4 rounded-xl text-center">
                  <span className="font-semibold text-slate-800">Obra en curso</span>
                </div>
              </div>
              <p className="text-gray-600">
                Nuestro rol es traducir diseño en solución constructiva viable, anticipando decisiones técnicas y productivas antes de que se conviertan en problemas de obra.
              </p>
            </div>
          </section>

          {/* Qué aportamos */}
          <section className="py-16 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold mb-8 text-gray-900">Qué aportamos al proyecto</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-white p-6 rounded-2xl shadow-sm">
                  <h3 className="font-bold text-xl mb-2 text-slate-800">Desarrollo ejecutivo</h3>
                  <p className="text-gray-600">Convertimos ideas en documentación técnica fabricable.</p>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-sm">
                  <h3 className="font-bold text-xl mb-2 text-slate-800">Optimización constructiva</h3>
                  <p className="text-gray-600">Ajustamos soluciones para mejorar eficiencia productiva sin alterar el diseño.</p>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-sm">
                  <h3 className="font-bold text-xl mb-2 text-slate-800">Definición técnica de materiales</h3>
                  <p className="text-gray-600">Especificamos materiales, herrajes y sistemas con criterio técnico.</p>
                </div>
                <div className="bg-white p-6 rounded-2xl shadow-sm">
                  <h3 className="font-bold text-xl mb-2 text-slate-800">Control de obra</h3>
                  <p className="text-gray-600">Supervisamos instalación para garantizar ejecución correcta.</p>
                </div>
              </div>
              
              <div className="mt-8 bg-white p-6 rounded-2xl shadow-sm">
                <p className="font-semibold text-gray-900 mb-4">Trabajar con método permite:</p>
                <div className="grid sm:grid-cols-2 gap-3">
                  <div className="flex items-center space-x-2">
                    <span className="text-green-600 text-xl">✓</span>
                    <span className="text-gray-700">Reducir incertidumbre</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-green-600 text-xl">✓</span>
                    <span className="text-gray-700">Evitar rediseños en obra</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-green-600 text-xl">✓</span>
                    <span className="text-gray-700">Costos más previsibles</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-green-600 text-xl">✓</span>
                    <span className="text-gray-700">Mejorar tiempos de ejecución</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="text-green-600 text-xl">✓</span>
                    <span className="text-gray-700">Coherencia entre unidades</span>
                  </div>
                </div>
                <p className="text-slate-600 italic mt-4">
                  La diferencia no está en el mueble, sino en el sistema que lo produce.
                </p>
              </div>
            </div>
          </section>

          {/* Flujo de trabajo */}
          <section className="py-16 bg-white">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold mb-8 text-gray-900">Nuestro flujo de trabajo con estudios</h2>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                {['Revisión de planos', 'Reunión técnica', 'Desarrollo ejecutivo', 'Presupuesto técnico', 'Producción', 'Instalación'].map((paso, i) => (
                  <div key={i} className="text-center">
                    <div className="bg-slate-800 text-white w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2 font-bold">{i + 1}</div>
                    <p className="text-sm text-gray-700">{paso}</p>
                  </div>
                ))}
              </div>
              <p className="text-center text-gray-500 mt-6">Cada instancia tiene responsables definidos y validaciones claras.</p>
            </div>
          </section>

          {/* Tipos de proyectos */}
          <section className="py-16 bg-gray-50">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold mb-6 text-gray-900">Tipos de proyectos</h2>
              <div className="flex flex-wrap gap-3 mb-4">
                <span className="bg-slate-100 text-slate-800 px-4 py-2 rounded-full">Viviendas unifamiliares</span>
                <span className="bg-slate-100 text-slate-800 px-4 py-2 rounded-full">Edificios residenciales</span>
                <span className="bg-slate-100 text-slate-800 px-4 py-2 rounded-full">Oficinas corporativas</span>
                <span className="bg-slate-100 text-slate-800 px-4 py-2 rounded-full">Espacios comerciales</span>
                <span className="bg-slate-100 text-slate-800 px-4 py-2 rounded-full">Hotelería</span>
              </div>
              <p className="text-gray-600">Con posibilidad de estandarización en desarrollos de múltiples unidades.</p>
            </div>
          </section>

          {/* Lo que no hacemos */}
          <section className="py-16 bg-slate-800 text-white">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <h2 className="text-3xl font-bold mb-6">Lo que no hacemos</h2>
              <p className="text-slate-300 mb-4">No trabajamos:</p>
              <ul className="space-y-3">
                <li className="flex items-center space-x-3">
                  <span className="text-red-400 text-xl">✗</span>
                  <span>Sin planos o definición básica</span>
                </li>
                <li className="flex items-center space-x-3">
                  <span className="text-red-400 text-xl">✗</span>
                  <span>Con decisiones exclusivamente en obra</span>
                </li>
                <li className="flex items-center space-x-3">
                  <span className="text-red-400 text-xl">✗</span>
                  <span>Bajo urgencias sin validación técnica</span>
                </li>
              </ul>
            </div>
          </section>

          {/* CTA Final */}
          <section className="py-20 bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
              <p className="text-2xl text-gray-900 mb-8">Si estás desarrollando un proyecto y necesitás un socio técnico confiable para el mobiliario:</p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <button onClick={() => { setCurrentPage('home'); setTimeout(() => scrollToSection('contacto'), 100); }} className="bg-slate-800 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-slate-700 transition-all">
                  Agendar reunión técnica
                </button>
                <button onClick={() => { setCurrentPage('home'); setTimeout(() => scrollToSection('contacto'), 100); }} className="border-2 border-slate-800 text-slate-800 px-8 py-4 rounded-full text-lg font-semibold hover:bg-slate-100 transition-all">
                  Enviar documentación
                </button>
              </div>
            </div>
          </section>
        </div>
      )}

      {currentPage === 'home' && (
        <>
          {/* Hero Section with Slider */}
          <section id="inicio" className="pt-20 min-h-screen flex items-center relative overflow-hidden">
            {/* Slider Images */}
            <div className="absolute inset-0 z-0">
              {heroSlides.map((image, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-opacity duration-1000 ${
                    index === currentSlide ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  {index === 0 ? (
                    <img 
                      src={image} 
                      alt={`Proyecto ${index + 1}`} 
                      className="w-full h-full object-cover"
                    />
                  ) : index <= 2 ? (
                    <div className="relative w-full h-full flex items-center">
                      <div 
                        className={`relative h-full ${
                          index % 2 === 1 ? 'ml-auto' : 'mr-auto'
                        }`}
                        style={{ width: '75%' }}
                      >
                        <img 
                          src={image} 
                          alt={`Proyecto ${index + 1}`} 
                          className="w-full h-full object-cover"
                        />
                        <div 
                          className={`absolute inset-y-0 w-32 ${
                            index % 2 === 1 
                              ? 'left-0 bg-gradient-to-r from-white to-transparent' 
                              : 'right-0 bg-gradient-to-l from-white to-transparent'
                          }`}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="relative w-full h-full">
                      <img 
                        src={image} 
                        alt={`Proyecto ${index + 1}`} 
                        className={`w-full h-full object-contain ${
                          index % 2 === 1 ? 'object-right' : 'object-left'
                        }`}
                      />
                      <div 
                        className={`absolute inset-y-0 w-32 ${
                          index % 2 === 1 
                            ? 'left-0 bg-gradient-to-r from-white to-transparent' 
                            : 'right-0 bg-gradient-to-l from-white to-transparent'
                        }`}
                      />
                    </div>
                  )}
                </div>
              ))}
              <div className="absolute inset-0 bg-gradient-to-r from-white/85 via-white/70 to-white/50"></div>
            </div>
            
            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 w-full">
              <div className="max-w-3xl">
                <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                  Ingeniería y fabricación de mobiliario a medida 
                </h1>
                <p className="text-xl sm:text-2xl text-gray-600 mb-8 leading-relaxed">
                  Industrializamos y ejecutamos proyectos con precisión técnica y cumplimiento real de obra para arquitectura y desarrollos inmobiliarios.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 mb-8">
                  <a 
                    href="https://wa.me/5491157525465" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="bg-slate-800 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-slate-700 transition-all transform hover:scale-105 flex items-center justify-center shadow-xl"
                    data-testid="hero-cotizar-button"
                  >
                    Cotizar Obra <ChevronRight className="ml-2" />
                  </a>
                  <button 
                    onClick={() => scrollToSection('portfolio')} 
                    className="border-2 border-slate-800 text-slate-800 px-8 py-4 rounded-full text-lg font-semibold hover:bg-slate-50 transition-all flex items-center justify-center"
                    data-testid="hero-portfolio-button"
                  >
                    Ver Portfolio
                  </button>
                </div>

                {/* Slider Indicators */}
                <div className="flex space-x-3">
                  {heroSlides.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className={`h-2 rounded-full transition-all ${
                        index === currentSlide 
                          ? 'w-12 bg-slate-800' 
                          : 'w-2 bg-slate-400 hover:bg-slate-600'
                      }`}
                      aria-label={`Ir a imagen ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Stats Section with Logo Carousel */}
          <section id="clientes" className="py-12 bg-slate-800 text-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="grid grid-cols-3 gap-8 text-center mb-10">
                <div className="transform hover:scale-105 transition-transform">
                  <div className="text-4xl sm:text-5xl font-bold mb-2">15+</div>
                  <div className="text-slate-300 text-sm sm:text-base">Años de Experiencia</div>
                </div>
                <div className="transform hover:scale-105 transition-transform">
                  <div className="text-4xl sm:text-5xl font-bold mb-2">500+</div>
                  <div className="text-slate-300 text-sm sm:text-base">Proyectos Completados</div>
                </div>
                <div className="transform hover:scale-105 transition-transform">
                  <div className="text-4xl sm:text-5xl font-bold mb-2">100%</div>
                  <div className="text-slate-300 text-sm sm:text-base">Proyectos a Medida</div>
                </div>
              </div>
              
              <div className="border-t border-slate-700 pt-8">
                <p className="text-center text-slate-400 text-sm mb-6">Confían en nosotros</p>
                <div className="overflow-hidden">
                  <div className="animate-marquee flex">
                    {[...Array(2)].map((_, i) => (
                      <div key={i} className="flex items-center space-x-8 px-4">
                        <div className="bg-white rounded-lg p-3 flex items-center justify-center" style={{minWidth: '120px', height: '50px'}}>
                          <img src="/images/clientes/Galicia.png" alt="Banco Galicia" style={{maxHeight: '35px', maxWidth: '100px', objectFit: 'contain'}} />
                        </div>
                        <div className="bg-white rounded-lg p-3 flex items-center justify-center" style={{minWidth: '120px', height: '50px'}}>
                          <img src="/images/clientes/Google.png" alt="Google" style={{maxHeight: '35px', maxWidth: '100px', objectFit: 'contain'}} />
                        </div>
                        <div className="bg-white rounded-lg p-3 flex items-center justify-center" style={{minWidth: '120px', height: '50px'}}>
                          <img src="/images/clientes/Cemic.svg" alt="CEMIC" style={{maxHeight: '35px', maxWidth: '100px', objectFit: 'contain'}} />
                        </div>
                        <div className="bg-white rounded-lg p-3 flex items-center justify-center" style={{minWidth: '120px', height: '50px'}}>
                          <img src="/images/clientes/Pedidos.png" alt="Pedidos Ya" style={{maxHeight: '35px', maxWidth: '100px', objectFit: 'contain'}} />
                        </div>
                        <div className="bg-white rounded-lg p-3 flex items-center justify-center" style={{minWidth: '120px', height: '50px'}}>
                          <img src="/images/clientes/Cabify.png" alt="Cabify" style={{maxHeight: '35px', maxWidth: '100px', objectFit: 'contain'}} />
                        </div>
                        <div className="bg-white rounded-lg p-3 flex items-center justify-center" style={{minWidth: '120px', height: '50px'}}>
                          <img src="/images/clientes/Farmacity.png" alt="Farmacity" style={{maxHeight: '35px', maxWidth: '100px', objectFit: 'contain'}} />
                        </div>
                        <div className="bg-white rounded-lg p-3 flex items-center justify-center" style={{minWidth: '120px', height: '50px'}}>
                          <img src="/images/clientes/Hit.png" alt="Hit Cowork" style={{maxHeight: '35px', maxWidth: '100px', objectFit: 'contain'}} />
                        </div>
                        <div className="bg-white rounded-lg p-3 flex items-center justify-center" style={{minWidth: '140px', height: '50px'}}>
                          <img src="/images/clientes/Caribbean.png" alt="Royal Caribbean" style={{maxHeight: '45px', maxWidth: '140px', objectFit: 'contain'}} />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Nosotros Section */}
          <section id="nosotros" className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">¿Qué es DreamWood?</h2>
              </div>

              <div className="max-w-4xl mx-auto">
                <div className="bg-white p-8 sm:p-12 rounded-3xl shadow-xl">
                  <p className="text-lg text-gray-700 leading-relaxed mb-6">
                    En <span className="font-bold text-slate-800">DreamWood</span> entendemos el mobiliario como parte integral de la arquitectura, no como un elemento agregado al final del proyecto. Contamos con diseñadores industriales, arquitectos, decoradores y carpinteros especializados que trabajan en conjunto para transformar las ideas de nuestros clientes en realidades tangibles y funcionales.
                  </p>
                  <p className="text-lg text-gray-700 leading-relaxed mb-8">
                    Trabajamos desde la lógica técnica: cada pieza responde a un sistema constructivo, a un proceso y a una decisión documentada. Diseñar sin pensar en cómo se fabrica genera fricción; fabricar sin ingeniería genera improvisación. Nuestro enfoque integra ambas dimensiones desde el inicio.
                  </p>
                  <div>
                    <p className="text-lg font-semibold text-slate-800 mb-4">Creemos en:</p>
                    <ul className="space-y-3">
                      <li className="flex items-start">
                        <span className="text-slate-800 mr-3">•</span>
                        <span className="text-lg text-gray-700">Precisión antes que intuición</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-slate-800 mr-3">•</span>
                        <span className="text-lg text-gray-700">Proceso antes que improvisación</span>
                      </li>
                      <li className="flex items-start">
                        <span className="text-slate-800 mr-3">•</span>
                        <span className="text-lg text-gray-700">Decisiones técnicas antes que soluciones de obra</span>
                      </li>
                    </ul>
                  </div>
                  <p className="text-lg text-gray-700 leading-relaxed mt-8">
                    Cada proyecto se aborda como un sistema que debe funcionar, producirse y montarse con coherencia.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Método DreamWood Section */}
          <section id="metodo" className="py-20 bg-white">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-16">
                <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">Método DreamWood</h2>
                <p className="text-xl text-gray-600">
                  Ingeniería aplicada al mobiliario a medida
                </p>
              </div>

              <div className="space-y-4">
                {[
                  { 
                    id: 1, 
                    title: 'Relevamiento técnico', 
                    objetivo: 'Traducir el espacio en información técnica verificable',
                    items: ['Medición del espacio', 'Detección de interferencias', 'Análisis de instalaciones', 'Evaluación de tolerancias', 'Revisión de planos'],
                    entregables: ['Relevamiento documentado', 'Base dimensional validada', 'Criterios técnicos iniciales'],
                    porque: 'El 80% de los errores se originan en relevamientos incompletos. Esta etapa reduce incertidumbre antes de diseñar.'
                  },
                  { 
                    id: 2, 
                    title: 'Desarrollo ejecutivo y modelado', 
                    objetivo: 'Convertir la idea en una solución construible',
                    items: ['Modelado del mobiliario', 'Definición de tipologías constructivas', 'Validación dimensional', 'Análisis de ergonomía', 'Coordinación con arquitectura'],
                    entregables: ['Modelos técnicos', 'Criterios constructivos definidos', 'Validación previa a presupuesto'],
                    porque: 'Permite anticipar decisiones que normalmente se resuelven en obra.'
                  },
                  { 
                    id: 3, 
                    title: 'Definición constructiva y presupuesto técnico', 
                    objetivo: 'Traducir el proyecto en información productiva',
                    items: ['Selección de materiales', 'Definición de herrajes y sistemas', 'Reglas constructivas aplicadas', 'Despiece técnico', 'Cálculo de costos reales'],
                    entregables: ['Presupuesto técnico', 'Especificaciones constructivas', 'Alcance definido'],
                    porque: 'No es un presupuesto comercial. Es un presupuesto basado en ingeniería y producción.'
                  },
                  { 
                    id: 4, 
                    title: 'Producción industrial', 
                    objetivo: 'Fabricar con consistencia, repetibilidad y control',
                    items: ['Mecanizado CNC', 'Control dimensional', 'Estandarización de piezas', 'Planificación productiva', 'Seguimiento de avance'],
                    entregables: ['Piezas listas para montaje', 'Control de calidad interno'],
                    porque: 'Reduce improvisación, tiempos muertos y errores en obra.'
                  },
                  { 
                    id: 5, 
                    title: 'Instalación y control en obra', 
                    objetivo: 'Garantizar que lo diseñado se ejecute correctamente',
                    items: ['Coordinación con obra', 'Montaje técnico', 'Ajuste final', 'Verificación funcional'],
                    entregables: ['Mobiliario instalado', 'Control final del proyecto'],
                    porque: 'El proyecto se ejecuta como fue pensado, no como se resuelve en el momento.'
                  }
                ].map((etapa) => (
                  <div key={etapa.id} className="border border-gray-200 rounded-2xl overflow-hidden">
                    <button
                      onClick={() => setActiveCapacidad(activeCapacidad === etapa.id ? null : etapa.id)}
                      className="w-full p-6 flex justify-between items-center text-left bg-gray-50 hover:bg-gray-100 transition-colors"
                    >
                      <div className="flex items-center">
                        <span className="text-2xl font-bold text-slate-800 mr-4">{etapa.id}</span>
                        <span className="text-xl font-semibold text-gray-900">{etapa.title}</span>
                      </div>
                      <span className="text-2xl text-slate-600">
                        {activeCapacidad === etapa.id ? '−' : '+'}
                      </span>
                    </button>
                    {activeCapacidad === etapa.id && (
                      <div className="p-6 bg-white">
                        <p className="text-slate-800 font-semibold mb-4">Objetivo: {etapa.objetivo}</p>
                        
                        <div className="grid md:grid-cols-2 gap-6 mb-4">
                          <div>
                            <p className="font-semibold text-gray-900 mb-2">Qué sucede:</p>
                            <ul className="space-y-1">
                              {etapa.items.map((item, i) => (
                                <li key={i} className="text-gray-600 flex items-start">
                                  <span className="text-slate-800 mr-2">•</span>{item}
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div>
                            <p className="font-semibold text-gray-900 mb-2">Entregables:</p>
                            <ul className="space-y-1">
                              {etapa.entregables.map((item, i) => (
                                <li key={i} className="text-gray-600 flex items-start">
                                  <span className="text-slate-800 mr-2">✓</span>{item}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        
                        <div className="bg-slate-50 p-4 rounded-xl">
                          <p className="text-slate-700"><span className="font-semibold">¿Por qué importa?</span> {etapa.porque}</p>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              
              <p className="text-center text-gray-500 mt-8 text-sm">
                Cada etapa tiene responsables, entregables y validaciones definidas.
              </p>
            </div>
          </section>

          {/* Portfolio Section */}
          <section id="portfolio" className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">Nuestro Portfolio</h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
                  Proyectos que reflejan nuestra pasión por la excelencia
                </p>

                <div className="flex flex-wrap justify-center gap-4">
                  <button
                    onClick={() => setActiveFilter('todos')}
                    className={`px-6 py-3 rounded-full font-semibold transition-all transform hover:scale-105 shadow-lg ${
                      activeFilter === 'todos' ? 'bg-slate-800 text-white' : 'bg-white text-gray-700 hover:bg-slate-50 border-2 border-slate-200'
                    }`}
                    data-testid="filter-todos"
                  >
                    Todos
                  </button>
                  <button
                    onClick={() => setActiveFilter('residencial')}
                    className={`px-6 py-3 rounded-full font-semibold transition-all transform hover:scale-105 shadow-lg ${
                      activeFilter === 'residencial' ? 'bg-slate-800 text-white' : 'bg-white text-gray-700 hover:bg-slate-50 border-2 border-slate-200'
                    }`}
                    data-testid="filter-residencial"
                  >
                    Residencial
                  </button>
                  <button
                    onClick={() => setActiveFilter('comercial')}
                    className={`px-6 py-3 rounded-full font-semibold transition-all transform hover:scale-105 shadow-lg ${
                      activeFilter === 'comercial' ? 'bg-slate-800 text-white' : 'bg-white text-gray-700 hover:bg-slate-50 border-2 border-slate-200'
                    }`}
                    data-testid="filter-comercial"
                  >
                    Comercial
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredPortfolio.map((item) => (
                  <div 
                    key={item.id} 
                    className="group relative overflow-hidden rounded-3xl shadow-xl cursor-pointer hover:shadow-2xl transition-all"
                    onClick={() => openLightbox(item.images, item.title, 0)}
                    data-testid={`portfolio-item-${item.id}`}
                  >
                    <img 
                      src={item.images[0]} 
                      alt={item.title} 
                      className="w-full h-96 object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-start justify-end p-6">
                      <h3 className="text-2xl font-bold text-white mb-2">{item.title}</h3>
                      <p className="text-gray-200 capitalize mb-2">{item.category}</p>
                      <p className="text-sm text-gray-300">{item.images.length} fotos • Click para ver más</p>
                    </div>
                    <div className="absolute top-4 right-4 bg-slate-800 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {item.images.length} fotos
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Lightbox Modal */}
            {lightboxOpen && (
              <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4" onClick={closeLightbox}>
                <button
                  onClick={closeLightbox}
                  className="absolute top-4 right-4 text-white hover:text-gray-300 text-4xl font-bold z-50"
                  aria-label="Cerrar"
                >
                  <X size={40} />
                </button>

                <button
                  onClick={(e) => { e.stopPropagation(); prevLightboxImage(); }}
                  className="absolute left-4 text-white hover:text-gray-300 text-4xl font-bold z-50 bg-slate-800/50 hover:bg-slate-800 rounded-full p-3 transition-all"
                  aria-label="Anterior"
                >
                  <ChevronRight size={40} className="rotate-180" />
                </button>

                <button
                  onClick={(e) => { e.stopPropagation(); nextLightboxImage(); }}
                  className="absolute right-4 text-white hover:text-gray-300 text-4xl font-bold z-50 bg-slate-800/50 hover:bg-slate-800 rounded-full p-3 transition-all"
                  aria-label="Siguiente"
                >
                  <ChevronRight size={40} />
                </button>

                <div className="max-w-6xl w-full" onClick={(e) => e.stopPropagation()}>
                  <img
                    src={lightboxImages[currentLightboxIndex]}
                    alt={`${lightboxTitle} - Foto ${currentLightboxIndex + 1}`}
                    className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
                  />
                  <div className="text-center mt-4">
                    <h3 className="text-white text-2xl font-bold mb-2">{lightboxTitle}</h3>
                    <p className="text-gray-300">
                      Foto {currentLightboxIndex + 1} de {lightboxImages.length}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </section>

          {/* Contacto Section */}
          <section id="contacto" className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="text-center mb-12">
                <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">Iniciemos tu Proyecto</h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                  Contanos tu idea y te responderemos a la brevedad
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <form onSubmit={handleSubmit} className="space-y-6" data-testid="contact-form">
                    {/* Honeypot field */}
                    <div style={{ position: 'absolute', left: '-9999px' }} aria-hidden="true">
                      <input
                        type="text"
                        name="website"
                        value={formData.website}
                        onChange={handleFormChange}
                        tabIndex="-1"
                        autoComplete="off"
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-semibold mb-2">Nombre</label>
                      <input
                        type="text"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleFormChange}
                        required
                        className="w-full px-4 py-3 border-b-2 border-gray-300 focus:outline-none focus:border-slate-800 bg-transparent"
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-semibold mb-2">Email</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleFormChange}
                        required
                        className="w-full px-4 py-3 border-b-2 border-gray-300 focus:outline-none focus:border-slate-800 bg-transparent"
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-semibold mb-2">Teléfono</label>
                      <input
                        type="tel"
                        name="telefono"
                        value={formData.telefono}
                        onChange={handleFormChange}
                        className="w-full px-4 py-3 border-b-2 border-gray-300 focus:outline-none focus:border-slate-800 bg-transparent"
                      />
                    </div>

                    <div>
                      <label className="block text-gray-700 font-semibold mb-2">Mensaje</label>
                      <textarea
                        name="mensaje"
                        value={formData.mensaje}
                        onChange={handleFormChange}
                        required
                        rows="4"
                        className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl focus:outline-none focus:border-slate-800 bg-transparent resize-none"
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      className="w-full bg-slate-800 text-white py-4 rounded-full font-semibold hover:bg-slate-700 transition-colors flex items-center justify-center"
                    >
                      Enviar Mensaje <ArrowRight className="ml-2" size={20} />
                    </button>

                    {formStatus === 'success' && (
                      <div className="bg-green-100 text-green-700 p-4 rounded-2xl text-center">
                        ¡Mensaje enviado correctamente! Te contactaremos pronto.
                      </div>
                    )}

                    {formStatus === 'error' && (
                      <div className="bg-red-100 text-red-700 p-4 rounded-2xl text-center">
                        Hubo un error. Por favor intenta nuevamente.
                      </div>
                    )}
                  </form>
                </div>

                <div className="space-y-8">
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-6">Información de Contacto</h3>
                    <div className="space-y-6">
                      <div className="flex items-start space-x-4">
                        <div className="bg-slate-800 p-2 rounded-full">
                          <Mail className="text-white" size={20} />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">Email</p>
                          <p className="text-gray-600">info@dreamwood.com.ar</p>
                        </div>
                      </div>
                      <div className="flex items-start space-x-4">
                        <div className="bg-slate-800 p-2 rounded-full">
                          <MapPin className="text-white" size={20} />
                        </div>
                        <div>
                          <p className="font-semibold text-gray-900">Ubicación</p>
                          <p className="text-gray-600">Francisco Álvarez, Provincia de Buenos Aires, Argentina</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-4">Seguinos</h3>
                    <div className="flex space-x-4">
                      <a href="https://www.facebook.com/dreamWoodArg/?locale=es_LA" target="_blank" rel="noopener noreferrer" className="bg-slate-800 p-3 rounded-full hover:bg-slate-700 transition-colors">
                        <Facebook className="text-white" size={20} />
                      </a>
                      <a href="https://www.instagram.com/dreamwoodarg" target="_blank" rel="noopener noreferrer" className="bg-slate-800 p-3 rounded-full hover:bg-slate-700 transition-colors">
                        <Instagram className="text-white" size={20} />
                      </a>
                      <a href="https://www.linkedin.com/company/dreamwood" target="_blank" rel="noopener noreferrer" className="bg-slate-800 p-3 rounded-full hover:bg-slate-700 transition-colors">
                        <Linkedin className="text-white" size={20} />
                      </a>
                    </div>
                  </div>

                  <div className="bg-slate-50 p-6 rounded-2xl">
                    <h3 className="text-xl font-bold text-gray-900 mb-4">¿Por qué elegirnos?</h3>
                    <ul className="space-y-3">
                      <li className="flex items-start">
                        <Check className="text-slate-800 mr-2 mt-1 flex-shrink-0" size={20} />
                        <span className="text-gray-600">Oficina técnica con profesionales especializados</span>
                      </li>
                      <li className="flex items-start">
                        <Check className="text-slate-800 mr-2 mt-1 flex-shrink-0" size={20} />
                        <span className="text-gray-600">Taller propio con tecnología de última generación</span>
                      </li>
                      <li className="flex items-start">
                        <Check className="text-slate-800 mr-2 mt-1 flex-shrink-0" size={20} />
                        <span className="text-gray-600">Supervisión constante en obra</span>
                      </li>
                      <li className="flex items-start">
                        <Check className="text-slate-800 mr-2 mt-1 flex-shrink-0" size={20} />
                        <span className="text-gray-600">Entrega en tiempos acordados</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Footer */}
          <footer className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-12">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                <div>
                  <h3 className="text-2xl font-bold text-slate-100 mb-4">DreamWood</h3>
                  <p className="text-slate-300">
                    Fabricación de muebles de calidad premium desde 2010
                  </p>
                </div>

                <div>
                  <h4 className="font-bold mb-4">Servicios</h4>
                  <ul className="space-y-2 text-slate-300">
                    <li>Trabajos Residenciales</li>
                    <li>Trabajos Comerciales</li>
                    <li>Proyectos Especiales</li>
                    <li>Oficina Técnica</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-bold mb-4">Contacto</h4>
                  <ul className="space-y-2 text-slate-300">
                    <li>info@dreamwood.com.ar</li>
                    <li>Francisco Álvarez, Buenos Aires</li>
                  </ul>
                </div>
              </div>

              <div className="border-t border-slate-700 pt-8 text-center text-slate-400">
                <p>&copy; 2025 DreamWood. Todos los derechos reservados.</p>
              </div>
            </div>
          </footer>
        </>
      )}

      {/* Botón flotante de WhatsApp */}
      <a
        href="https://wa.me/5491157525465"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-110 z-50"
        aria-label="Contactar por WhatsApp"
        data-testid="whatsapp-floating-button"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="36" 
          height="36" 
          viewBox="0 0 24 24" 
          fill="currentColor"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>
    </div>
  );
}

export default App;
